import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { OCRCollisionMessageProps } from "models/propTypes/incomingInvoicePropTypes";
//#endregion
//#region components
import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Icon } from "components/common";
//#endregion
import { UrlHelper, LocalizationHelperInstance } from "utils/helpers";

const OCRCollisionMessage: React.FC<OCRCollisionMessageProps> = (props) => {
  const { ocrCollisions } = props;

  return ocrCollisions.length > 0 ? (
    <>
      {`${LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.IncomingInvoice.PossibleDuplcateWarningMessage
      )} `}

      {ocrCollisions.map((c) => (
        <Link key={`duplicateOCR-${c}`} component={RouterLink} to={UrlHelper.formatPath(`/IncomingInvoice/${c}`)}>
          <>
            {` ${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ViewInvoice)} ${
              ocrCollisions.length > 1 ? c : ""
            } `}
            <Icon icon={IconDefinitionConstants.WArrowSmallRight} />
          </>
        </Link>
      ))}
    </>
  ) : (
    <></>
  );
};

export default OCRCollisionMessage;
